<template>
<!-- 账号中心页面（代理商） -->
  <div class="account-page">
    <!-- 页面头部：标题 + 代理商充值 -->
    <div class="account-page__header">
      <div class="account-page__title">
        <span class="account-page__title-bar"></span>
        <span class="account-page__title-text">{{ $t('app.router.accountCenter') }}</span>
      </div>
      <div class="account-page__actions">
        <div class="balance-pill">
          <span class="balance-label">账户余额</span>
          <span class="balance-value">¥{{ availAmount }}</span>
        </div>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-plus"
          v-if="showAgentRecharge"
          @click="agentAccountPay"
        >代理商充值</el-button>
      </div>
    </div>

    <!-- 页面主体：明细 / 余额 tab -->
    <div class="account-page__body">
      <tabList :key="listRefreshKey"></tabList>
    </div>

    <!-- 代理商充值弹窗 -->
    <el-dialog
      title="代理商充值"
      :visible.sync="agentPayDialog"
      width="700px"
      top="5vh"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <!-- Boolean  embedded 不写值就等于`true` -->
      <system-pay embedded @success="onAgentPaySuccess" />
    </el-dialog>
  </div>
</template>
<script>
import tabList from "@/views/scale/tabList.vue";
import SystemPay from "@/views/users/systemPay.vue";
import { userInfo } from "@/api/api.js"; //获取当前用户信息（余额）
export default {
  data() {
    return {
      agentPayDialog: false,
      listRefreshKey: 0,
      availAmount: "--",
    };
  },
  components: {
    tabList,
    SystemPay
  },
  computed: {
    showAgentRecharge(){
      return this.$store.getters.user.userId == this.$store.getters.xrsUserId
    }
  },
  methods: {
    // 代理商充值：打开弹窗
    agentAccountPay(){
      this.agentPayDialog = true;
    },
    // 代理商充值成功回调
    onAgentPaySuccess(){
      this.agentPayDialog = false;
      this.$message.success("代理商充值成功");
      this.listRefreshKey += 1;
      this.getBalance();
    },
    // 获取当前代理商余额
    getBalance(){
      let params = {
        userId: localStorage.getItem("userId")
      };
      userInfo(params).then(res => {
        if (res.data.code == 200) {
          this.availAmount = this.formatAmount(res.data.data.availAmount);
        }
      })
    },
    // 金额格式化：千分位 + 两位小数
    formatAmount(num){
      if(num === null || num === undefined || num === '') return '--';
      const n = Number(num).toFixed(2);
      const parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,') + '.' + parts[1];
    }
  },
  mounted() {
    this.getBalance();
  }
};
</script>
<style scoped lang="less">
.account-page{
  width: 100%;
  padding: 16px 20px;
  box-sizing: border-box;
}
.account-page__header{
  display: flex;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #eee;
}
.account-page__title{
  display: flex;
  align-items: center;
  margin-right: 12px;
}
.account-page__title-bar{
  display: inline-block;
  width: 4px;
  height: 16px;
  margin-right: 8px;
  border-radius: 2px;
  background: #409eff;
}
.account-page__title-text{
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
.account-page__actions{
  display: flex;
  align-items: center;
}
.balance-pill{
  display: inline-flex;
  align-items: center;
  height: 32px;
  margin-right: 12px;
  padding: 0 14px;
  box-sizing: border-box;
  border-radius: 4px;
  background: #fdf0f0;
  border: 1px solid #fde2e2;
}
.balance-label{
  font-size: 13px;
  color: #909399;
  margin-right: 8px;
}
.balance-value{
  font-size: 16px;
  font-weight: 600;
  color: #f56c6c;
}
.account-page__body{
  padding-top: 8px;
}
/deep/ .el-tabs__item{
  font-size: 14px;
}
/deep/ .el-date-editor .el-range-separator{
  width: 6%;
}
</style>
